<template>
    <kimsa-confirm ref="confirm" :title="title" :content="content"
        :confirm-label="$t('common.accept')" alert-mode />
</template>

<script>

import KimsaConfirm from '@/components/common/KimsaConfirm'
import moment from 'moment'

export default {
    name: 'DeletedAccountDialog',
    components: { KimsaConfirm },
    data() {
        return {
            info: null,
            mode: 'login',
        }
    },
    computed: {
        title(vm = this) {
            return vm.mode === 'signup'
                ? vm.$t('entrance.deleted_account_signup_title')
                : vm.$t('entrance.deleted_account_login_title')
        },
        content(vm = this) {
            if (!vm.info) return ''

            const key = vm.mode === 'signup'
                ? 'entrance.deleted_account_signup_body'
                : 'entrance.deleted_account_login_body'

            if (!vm.info.expiresAt) return vm.$t(`${key}_no_date`)

            return vm.$t(key, {
                deletedAt: vm.formatDate(vm.info.deletedAt),
                expiresAt: vm.formatDate(vm.info.expiresAt),
                days: vm.info.daysLeft,
            })
        },
    },
    methods: {
        formatDate(value) {
            return value ? moment(value).format('DD/MM/YYYY') : ''
        },
        show(info, mode = 'login') {
            const vm = this
            vm.info = info
            vm.mode = mode
            vm.$refs.confirm.show()
        },
    },
}
</script>
